import React from 'react';
import { Spin, Result } from 'antd';
import { useDynamicRuntimeFormConfig } from '@/modules/action-flow/config/hooks/use-action-flow';
import DynamicWorkflowForm from '@/modules/action-flow/runtime/components/dynamic-form/DynamicWorkflowForm';

interface ApprovalPageProps {
    domain: string;
    subscriptionId: string;
    initialData: any;
    onSubmit: (values: any) => void;
    customComponents: Record<string, React.ComponentType<any>>;
    nodeId?: string;
}

const ApprovalPage: React.FC<ApprovalPageProps> = ({
    domain,
    subscriptionId,
    initialData,
    onSubmit,
    customComponents,
    nodeId,
}) => {
    const { config: configJson, isLoading, isError } = useDynamicRuntimeFormConfig(domain, subscriptionId, nodeId);

    if (isLoading) return <Spin size="large" />;
    if (isError || !configJson) {
        return (
            <Result
                status="error"
                title="Configuration Error"
                subTitle="Failed to load workflow form configuration."
            />
        );
    }

    let parsedConfig;
    try {
        parsedConfig = typeof configJson === 'string' ? JSON.parse(configJson) : configJson;
    } catch {
        return (
            <Result
                status="error"
                title="Configuration Error"
                subTitle="Invalid workflow form configuration."
            />
        );
    }

    return (
        <DynamicWorkflowForm
            config={parsedConfig}
            initialData={initialData}
            onSubmit={onSubmit}
            customComponents={customComponents}
        />
    );
};

export default ApprovalPage;
